import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useAnalytics } from '@listening/frontend/analytics/client';
import { useAuthSession } from '@/services/auth-service';
import { DEFAULT_FUNNEL_FLOW, type FunnelFlow } from '../config/funnels';
import { SqueezeDevices } from './squeeze-devices';
import { SqueezeFeatures } from './squeeze-features';
import { SqueezeFinalCta, SqueezeFooter } from './squeeze-footer';
import { SqueezeHero } from './squeeze-hero';
import { SqueezeNav } from './squeeze-nav';
import { SqueezeSocialProof } from './squeeze-social-proof';

export function SqueezePage({
  campaign,
  flow = DEFAULT_FUNNEL_FLOW,
}: {
  campaign: string;
  flow?: FunnelFlow;
}) {
  const { capture } = useAnalytics();
  const navigate = useNavigate();
  const { user } = useAuthSession();

  useEffect(() => {
    capture('squeeze_viewed', { campaign });
  }, [campaign, capture]);

  function onCta(ctaLocation: string) {
    capture('squeeze_cta_clicked', {
      campaign,
      cta_location: ctaLocation,
      signed_in: !!user,
    });
    if (user) {
      void navigate({ to: '/app/home' });
      return;
    }
    void navigate({
      to: '/onboarding/$step',
      params: { step: 'welcome' },
      search: flow === DEFAULT_FUNNEL_FLOW ? {} : { flow },
    });
  }

  return (
    <main className='overflow-x-clip bg-white font-sans text-neutral-900'>
      <SqueezeNav onCta={() => onCta('nav')} />
      <SqueezeHero onCta={() => onCta('hero')} />
      <SqueezeSocialProof />
      <SqueezeFeatures />
      <SqueezeDevices />
      <SqueezeFinalCta onCta={() => onCta('final')} />
      <SqueezeFooter />
    </main>
  );
}
